(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var DateRangeEnum = {
  ONE_MONTH: '1M',
  THREE_MONTH: '3M',
  SIX_MONTH: '6M',
  NINE_MONTH: '9M',
  ONE_YEAR: '1Y',
  TWO_YEAR: '2Y',
  MAX: 'ALL'
};
var _default = DateRangeEnum;
export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(DateRangeEnum, "DateRangeEnum", "/home/runner/html/nextcloud/apps/ehr/js/platform/core/src/enums/DateRange.enum.js");
  reactHotLoader.register(_default, "default", "/home/runner/html/nextcloud/apps/ehr/js/platform/core/src/enums/DateRange.enum.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();